import React from 'react';
import "./Checkout.css";
import {useStateValue} from "./StateProvider";
import CheckoutProduct from './CheckoutProduct';
import Subtotal from './Subtotal';

function Checkout() {
    const [{basket, user}, ] = useStateValue();
  return (
    <div className="checkout">
        <div className="checkout_left">
            <img className="checkout_ad" src="https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492668_.jpg" alt="" />
            <div>
                <h3>مرحبا, {user?.email}</h3>
                <h2 className="checkout_title">سلة التسوق الخاصة بك</h2>
                {/* CHECKOUT PRODUCT */}
                {basket.map((item) => (
                    <CheckoutProduct 
                        id={item.id}
                        title={item.title}
                        image={item.image}
                        price={item.price}
                        rating={item.rating}
                    />
                ))}
            </div>
        </div>
        <div className='checkout_right'>
            <Subtotal/>
        </div>
    </div>
  )
}

export default Checkout
